"use client"
import { FooterApi, FooterApi3, FooterApi4, ThemeApi } from "~/routes/footer.routes";
import Link from "next/link";
import { Button } from "../ui/button";
import { useTheme } from "next-themes"

const currentYear = new Date().getFullYear();
 
const Footer = () => {
    const { setTheme } = useTheme();

    const reLinkCss = `inline-block py-1 pr-2 transition-transform hover:scale-105`
    const reIconCss = `opacity-80 transition-opacity hover:opacity-100`

  return (
    <footer className="relative w-full">
      <div className="w-full px-8 mx-auto max-w-7xl">
        <div className="grid w-full grid-cols-1 gap-8 py-12 mx-auto md:grid-cols-2 lg:grid-cols-4">
              {FooterApi4.map((item, index) => (
                <div className="w-full" key={index}>
                  <p className="mb-4 font-bold uppercase opacity-50">
                      {item.title}
                    </p>
                    {item.add.map(([link, value, blank], index) => (
                      <ul className="space-y-1" key={index}>
                        <li>
                            <Link href={link} target={blank} className={`${reLinkCss} hover:scale-100`}>{value}</Link>
                        </li>
                      </ul>
                    ))}
                </div>
              ))}
          {FooterApi.map(({ name, link }, key) => (
            <div key={key} className="w-full">
              <p className="mb-4 font-bold uppercase opacity-50">
                {name}
              </p>
              <ul className="space-y-1">
                {link.map((link, i) => (
                  <li className="font-normal" key={i}>
                    <Link href={link.link} className={`${reLinkCss}`}>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex my-2 gap-4 justify-start lg:justify-end">
          {ThemeApi.map(item => (
            <Button key={item.id} variant={"outline"} size={"icon"} onClick={() => setTheme(item.id)}>
              {item.icon(20)}
            </Button>
          ))}
        </div>
        <div className="flex flex-col items-center justify-center w-full py-4 border-t md:flex-row md:justify-between">
          <span className="mb-4 font-normal text-center md:mb-0">
            &copy; {currentYear} <Link href="/">Dev Mobile</Link>. All
            Rights Reserved.
          </span>
          <div className="flex gap-4 sm:justify-center">
            {FooterApi3.map((item, index) => (
                <Link onClick={() => window.open(item.link, "_blank")} href={item.link} target="_blank" className={`${reIconCss}`} key={index}>
                    {item.icon(20)}
                </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export { Footer }